import { useTranslation } from 'react-i18next';
import { guides } from '@/mocks/categories';

export default function GuidesSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="py-12 md:py-16 bg-stone-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800 mb-3">
            {t('guides_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-5xl mx-auto">
          {guides.map((guide) => (
            <a
              key={guide.id}
              href={guide.path}
              className="group flex flex-col overflow-hidden rounded-xl bg-white border border-stone-200 hover:border-emerald-300 hover:-translate-y-0.5 transition-all"
            >
              <div className="w-full aspect-[4/3] overflow-hidden bg-stone-100">
                <img
                  src={guide.image}
                  alt={t(guide.nameKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4">
                <span className="text-xs md:text-sm font-medium text-stone-800 leading-snug group-hover:text-emerald-700 transition-colors">
                  {t(guide.nameKey)}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="/cssbuy-spreadsheet/"
            className="inline-flex items-center gap-2 text-sm font-medium text-emerald-700 hover:text-emerald-800 transition-colors"
          >
            {t('guides_cta')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}